import legalEntities from 'modules/core/store/collections/legalEntities'

import { companyMainLocation } from 'modules/locations/store/collections/locations'

import { getRegion } from '../lib/pricing/calculator/getPricing'

const usePricingLocation = (isStarterPlan = false) => {
  const country = legalEntities.main ? legalEntities.main.country : companyMainLocation().country

  return { country, region: getRegion(country, isStarterPlan) }
}

export default usePricingLocation
